<style lang="scss">
@import './../../../../../sass/brcom/settings/_settings.theme-colors.scss';

.extra-payment-errors {
  color: $theme-red-dark;
  font-family: 'Calibre-Regular', Arial, sans-serif;
}
.extraPaymentsRoot .note {
  font-size: 80%;
  vertical-align: -8px;
}
.extraPaymentsDiv .number-input__error {
  position: absolute;
}
.extraPaymentsDiv label.form-label {
  text-align: left;
}
</style>
<script>
import moment from 'moment'
import utils from 'apps/utility/vue-common'
import numberInput from 'apps/bankrate-calculators/components/number-input.vue'
import dropDown from 'apps/bankrate-calculators/components/dropdown.vue'
import toggleLink from 'apps/bankrate-calculators/components/toggle-link.vue'
import calculatorEventBus from 'apps/bankrate-calculators/events'

export default {
  template: utils.methods.isDesktop()
    ? require('./template.html')
    : require('./mobile-template.html'),
  components: { numberInput, dropDown, toggleLink },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    calcType: {
      type: String
    },
    fullVersion: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      errors: [],
      monthDropDownItems: [],
      yearDropDownItems: [],
      extraPaymentDate: this.$store.state.oneTimeExtraPaymentDate
    }
  },
  computed: {
    isOpen() {
      return this.$store.state.extraPaymentsDivOpen
    },
    errorsOnPage() {
      return this.$store.getters.pageHasErrors
    }
  },
  methods: {
    toggleExtraPaymentsDiv(event) {
      this.$store.dispatch('trackClick', {
        event,
        text: this.isOpen ? 'hide extra payments' : 'add extra payments'
      })
      if (this.isOpen) {
        this.$store.dispatch('setState', {
          name: 'monthlyExtraPayment',
          value: 0
        })
        this.$store.dispatch('setState', {
          name: 'yearlyExtraPayment',
          value: 0
        })
        this.$store.dispatch('setState', {
          name: 'oneTimeExtraPayment',
          value: 0
        })
        calculatorEventBus.$emit('calculator:calculation')
        if (this.$store.getters.dataChanged) {
          calculatorEventBus.$emit('amortizationDataChanged')
        }
      }
      this.$store.dispatch('setState', {
        name: 'extraPaymentsDivOpen',
        value: !this.isOpen
      })
    },
    setError(fieldName, error) {
      this.errors.push(error)
      this.$store.commit('setPageErrors', { name: fieldName, error: true })
    },
    validateExtraPayments() {
      // reset errors
      this.errors = []
      const store = this.$store.state
      const startDate = moment(store.startDate, 'MM/DD/YYYY')

      if (store.loanAmount < store.monthlyExtraPayment) {
        this.setError(
          'monthlyExtraPayment',
          '* Extra monthly payment cannot be more than the loan amount.'
        )
      }
      if (store.loanAmount < store.yearlyExtraPayment) {
        this.setError(
          'yearlyExtraPayment',
          '* Extra yearly payment cannot be more than the loan amount.'
        )
      }
      if (store.loanAmount < store.oneTimeExtraPayment) {
        this.setError(
          'oneTimeExtraPayment',
          '* One time payment cannot be more than loan amount.'
        )
      }
      if (store.oneTimeExtraPayment > 0) {
        if (store.oneTimeExtraPaymentDate.isBefore(startDate)) {
          this.setError(
            'oneTimeExtraPaymentDate',
            '* Single payment cannot be made before the start date.'
          )
        } else if (
          store.oneTimeExtraPaymentDate.month() === startDate.month()
        ) {
          this.setError(
            'oneTimeExtraPaymentDate',
            '* Single payment must be made at least a month after loan start date.'
          )
        }
      }
    },
    applyExtraPayments(event) {
      this.$store.dispatch('trackClick', { event })
      this.$nextTick(() => {
        calculatorEventBus.$emit('calculator:calculation')
        this.validateExtraPayments()
        calculatorEventBus.$emit('amortizationDataChanged')
      })
    }
  },
  created() {
    let year = moment().year()
    for (let i = 0; i < 12; i++) {
      const format = utils.methods.isDesktop() ? 'MMMM' : 'MMM'
      this.monthDropDownItems.push({
        value: i,
        name: moment(i + 1, 'MM').format(format)
      })
    }
    for (let i = 0; i < this.config.termInYears.max; i++) {
      this.yearDropDownItems.push({ value: year + i, name: String(year + i) })
    }
  }
}
</script>
